import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { spacing, borderRadius, colors, IconStopwatchMedium } from "@izettle/otto"
import { Text, SvgIcon } from "@izettle/react"

import { theme } from "@/theme"

const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${spacing.xxSmall};
  margin-bottom: ${spacing.none};
  position: relative;
  padding: ${spacing.small};
  border: 1px solid transparent;
  border-radius: ${borderRadius.medium};
  background-color: ${colors.message.background.info};
  color: ${colors.text.info};
`

const Icon = styled(SvgIcon)`
  margin-right: ${spacing.small};

  @media ${theme.devices.tinyMobile} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: inline;
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const ItemTitle = styled(Text.RegularBold)`
  padding: ${spacing.none};
  margin: ${spacing.none};
  color: ${colors.text.info};
`

const ItemText = styled(Text.SmallSecondary)`
  padding: ${spacing.none};
  margin: ${spacing.none};
`

type CompletedItemProps = {
  name: string
  description: string
}

export const CompletedItem: React.FC<CompletedItemProps> = ({ name, description }) => {
  const { text } = useLocalization()

  return (
    <ListItem role="listitem" aria-label={`${text("COMPLETED_ICON_TITLE")}. ${name}`}>
      <Icon icon={IconStopwatchMedium} alt="" />
      <TextWrapper>
        <ItemTitle aria-hidden>{name}</ItemTitle>
        <ItemText aria-hidden>{description}</ItemText>
      </TextWrapper>
    </ListItem>
  )
}
